import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { AdSupplier, CreateAdSupplier, UpdateAdSupplier } from '@magnetar/admin-api-interfaces'

export const adSupplierService = {
  createAdSupplier: async (data: CreateAdSupplier, token: string) => {
    try {
      const response = await apiClient.post<{ success: boolean; data: AdSupplier }>(
        '/api/ad-suppliers',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  updateAdSupplier: async (supplierId: number, data: UpdateAdSupplier, token: string) => {
    try {
      const response = await apiClient.put<{ success: boolean; data: AdSupplier }>(
        `/api/ad-suppliers/${supplierId}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  deleteAdSupplier: async (supplierId: number, token: string) => {
    try {
      const response = await apiClient.delete<{ success: boolean }>(
        `/api/ad-suppliers/${supplierId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },
}
